export const AdornmentType = {
  START: 'startAdornment',
  END: 'endAdornment',
};

export const AdornmentPosition = {
  START: 'start',
  END: 'end',
};

export const ADORNMENT_TYPE_TO_POSITION_MAP = {
  [AdornmentType.START]: AdornmentPosition.START,
  [AdornmentType.END]: AdornmentPosition.END,
};
